import { useDocumentDownload } from "@/components/Project/index.ts";
import type { Project } from "@/queries/project.ts";
import DownloadIcon from "@mui/icons-material/Download";
import { Backdrop, CircularProgress, ListItemButton, ListItemText } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
    label: string;
    project: Project;
    documentKey: keyof Project["documentObjectKeys"];
};

const DocumentListItem = ({ label, project, documentKey }: Props): ReactNode => {
    const { downloading, startDownload } = useDocumentDownload(project.id, documentKey);

    return (
        <ListItemButton onClick={startDownload}>
            <ListItemText primary={label} />
            <DownloadIcon />
            <Backdrop open={downloading}>
                <CircularProgress />
            </Backdrop>
        </ListItemButton>
    );
};

export default DocumentListItem;
